export const environment = {
  production: true,
  buildId: '3035795341720021',
  configFile: 'config.json',
};
